/* Belt-and-suspenders for Woobox text color.
   Some browsers (notably iOS Safari and Mac Safari on soft refresh) end up with Woobox-
   injected form elements rendered white-on-white because the SDK copies the parent's
   computed color into inline styles, and inline styles beat any CSS rule. We force the
   inline color on every .woobox-offer descendant after the SDK has injected its HTML.

   Cross-origin iframe contents (woobox.com/...) cannot be reached from the parent
   document; if a particular embed renders as an iframe instead of inline DOM, this
   script has no effect on that case and the form's colors must be configured in the
   Woobox dashboard. */
(function () {
  function forceBlack() {
    var offers = document.querySelectorAll('.woobox-offer');
    if (!offers.length) return;
    offers.forEach(function (offer) {
      offer.style.setProperty('color', '#000', 'important');
      var descendants = offer.querySelectorAll(
        '*:not(input):not(button):not(select):not(textarea):not(a)'
      );
      descendants.forEach(function (el) {
        el.style.setProperty('color', '#000', 'important');
      });
      var links = offer.querySelectorAll('a');
      links.forEach(function (a) {
        a.style.setProperty('color', '#0a58ca', 'important');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceBlack);
  } else {
    forceBlack();
  }

  // Re-apply on each Woobox render pass — the SDK can inject content asynchronously
  // and after orientation/resize on mobile.
  [50, 200, 600, 1500, 3000, 6000].forEach(function (delay) {
    setTimeout(forceBlack, delay);
  });

  // Fire on window 'load' (after all resources, including the SDK script).
  window.addEventListener('load', forceBlack);

  // iOS Safari throttles timers/observers until a user gesture lands. Hook every
  // interaction primitive so the moment the user touches, scrolls, or focuses the page
  // (or even rotates), we re-paint the colors.
  ['touchstart', 'touchend', 'click', 'focusin', 'scroll', 'pointerdown', 'visibilitychange', 'orientationchange', 'resize'].forEach(function (evt) {
    window.addEventListener(evt, forceBlack, { passive: true, capture: true });
  });

  // Re-fire when the .woobox-offer scrolls into view — iOS will have woken JS up by then.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) forceBlack();
      });
    });
    var attachIO = function () {
      document.querySelectorAll('.woobox-offer').forEach(function (el) {
        io.observe(el);
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachIO);
    } else {
      attachIO();
    }
  }

  // MutationObserver catches any later DOM changes inside .woobox-offer (e.g. when the
  // SDK reflows the form after a step transition).
  if ('MutationObserver' in window) {
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        forceBlack();
        pending = false;
      });
    });
    var attach = function () {
      document.querySelectorAll('.woobox-offer').forEach(function (el) {
        observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    } else {
      attach();
    }
  }
})();
